import { InputOptions } from '@features/filters/interfaces/filters.interfaces';
import { FilterList } from '@mui/icons-material';
import { Button, Grid, ThemeProvider } from '@mui/material';
import filtersTheme from '@themes/filters.theme';
import { handleFiltersButtonClick } from './FiltersContainer.handlers';
import { generateInput } from './FiltersContainer.helpers';
import useFiltersContainerStyles from './FiltersContainer.styles';

interface Props {
	counter?: number;
	id: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	inputs: InputOptions<any>[];
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	name: string | null;
}

const FiltersContainer: React.FC<Props> = ({
	counter = 0,
	id,
	inputs,
	isOpen,
	setIsOpen,
	name,
}) => {
	const classes = useFiltersContainerStyles();

	return (
		<ThemeProvider theme={filtersTheme}>
			<Grid
				container
				alignItems="center"
				justifyContent="flex-end"
				id={`${id}-filters-container`}
				spacing={1}
			>
				{isOpen && (
					<>
						{inputs.map((input, i) => (
							<Grid item key={`${id}_input_${i}`}>
								{generateInput(id, input)}
							</Grid>
						))}
					</>
				)}
				<Grid item>
					<Button
						color={counter > 0 ? 'primary' : 'secondary'}
						onClick={handleFiltersButtonClick(isOpen, setIsOpen)}
						startIcon={
							counter > 0 ? (
								<div className={classes.filterCounter}>{counter}</div>
							) : (
								<FilterList />
							)
						}
						className={name === null ? classes.buttonNull : classes.button}
						variant={counter > 0 ? 'contained' : 'outlined'}
						sx={{
							textTransform: 'none',
							border: '1px solid #CCCCCC',
							borderRadius: '5px',
							'&:hover': {
								backgroundColor: '#6868680D',
							},
							background: 'white',
							'& .MuiButton-startIcon': {
								margin: name === null ? '0px' : '0px 8px 0px -4px',
							},
						}}
					>
						{name}
					</Button>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
};

export default FiltersContainer;
